import {
	ADD_DICTPLATFORM,
	UPDATE_DICTPLATFORM,
	DELETE_DICTPLATFORM,
	GET_DICTPLATFORM_LIST,
} from '../constant';
import {
	getDictPlatformsApi,
	addDictPlatformApi,
	updateDictPlatformApi,
	deleteDictPlatformApi,
} from '../../api';

export const getDictPlatforms = (data) => ({
	type: GET_DICTPLATFORM_LIST,
	data,
});

export const addDictPlatform = (data) => ({
	type: ADD_DICTPLATFORM,
	data,
});

export const updateDictPlatform = (data) => ({
	type: UPDATE_DICTPLATFORM,
	data,
});

export const deleteDictPlatform = (data) => ({
	type: DELETE_DICTPLATFORM,
	data,
});

export const getDictPlatformsAsync = (params) => {
	const pageSize = 15;
	params = { ...params, pageSize };
	return (dispatch) => {
		return getDictPlatformsApi(params)
			.then((data) => {
				if (data.errorCode.trim().length === 0) {
					const totalCount = (data.value as any)?.total ?? 0;
					const totalpage =
						parseInt(parseInt(totalCount) / pageSize + '') +
						(totalCount % pageSize > 0 ? 1 : 0);
					dispatch(
						getDictPlatforms({
							data: (data.value as any)?.data ?? [],
							total: totalpage,
						})
					);
				} else {
					console.error(`${data.errorCode}:: ${data.errorMessage}`);
				}
			})
			.catch((error) => {
				throw error;
			});
	};
};

export const addDictPlatformAsync = (data) => async (dispatch) => {
	try {
		const response = await addDictPlatformApi(data);
		if (response.errorCode.trim().length === 0) {
			dispatch(addDictPlatform(response.value));

			return Promise.resolve(response.value);
		} else {
			return Promise.reject(response.errorMessage);
		}
	} catch (error) {
		return Promise.reject(error);
	}
};

export const updateDictPlatformAsync = (data) => async (dispatch) => {
	try {
		const response = await updateDictPlatformApi(data);
		if (response.errorCode.trim().length === 0) {
			dispatch(updateDictPlatform(response.value));

			return Promise.resolve(response.value);
		} else {
			return Promise.reject(response.errorMessage);
		}
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteDictPlatformAsync = (data) => async (dispatch) => {
	try {
		const response = await deleteDictPlatformApi(data);
		if (response.errorCode.trim().length === 0) {
			dispatch(deleteDictPlatform(response.value));

			return Promise.resolve(response.value);
		} else {
			return Promise.reject(response.errorMessage);
		}
	} catch (error) {
		return Promise.reject(error);
	}
};
